module.exports = __webpack_public_path__ + "img/AIM-logo.48cd651d.png";